// 满意度评估
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table, Tooltip } from 'antd'
import './index.less'
const { WizSpin, WizButton, WizModal, WizCard, WizForm, WizRow, WizCol, WizDatePicker } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool
import moment from "moment";
import assembleColumns from './columns'

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/integrationCounseling/manager/track/satisfactionEvaluation') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('trackSatisfactionEvaluation', record)
    } else {
      record = Session.get('trackSatisfactionEvaluation') || {}
    }
  }
  return record
}

class SatisfactionEvaluation extends WizContainer {

  componentName = 'SatisfactionEvaluation'

  constructor(props) {
    super(props)
    let record = findParamRecord(props.history)
    this.state = {
      record,
      headList: [],
      dataList: [],
      visible: false,
      modalTitleType: 1, // 1新增 2查看 3编辑 
      modalInfo: {},
      inputParam: []
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/trackSatisfactionPageList',
      payload: {
        key: 'trackSatisfactionPageList@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId
        }
      }
    })
  }

  getCheck = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/trackCheckSatisfaction',
      payload: {
        key: 'trackCheckSatisfaction@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId
        }
      }
    })
  }

  markConfirmed = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/satisfactionEvaluationNoticeTargetConfirm',
      payload: {
        key: 'satisfactionEvaluationNoticeTargetConfirm@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId,
          tutorContentId: processContentId
        }
      }
    })
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this),
    markConfirmed: this._markConfirmed.bind(this),
    trackInputTrackSatisfactionMonth: this._trackInputTrackSatisfactionMonth.bind(this),
    trackCheckSatisfaction: this._trackCheckSatisfaction.bind(this),
    trackSatisfactionMonthUpdate: this._trackSatisfactionMonthUpdate.bind(this),
    trackSatisfactionMonthDelete: this._trackSatisfactionMonthDelete.bind(this),
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.headList = data.headList
      nextState.dataList = data.dataList
      return true
    }
    wizNotice.error(msg || '获取满意度列表失败')
    return false
  }

  _trackCheckSatisfaction(nextProps, nextState) {
    let { trackCheckSatisfaction } = nextProps
    let { success, msg, data } = trackCheckSatisfaction
    if (success) {
      nextState.inputParam = data
      this._onBtn(1)
      return true
    }
    wizNotice.error(msg || '获取满意度参数列表失败')
    return false
  }


  _markConfirmed(nextProps, nextState) {
    let { markConfirmed } = nextProps
    let { success, msg } = markConfirmed
    if (success) {
      wizNotice.success(msg)
      this.jumpPage('goBack')
      return true
    }
    wizNotice.error(msg || '达标确认失败')
    return false
  }

  _trackInputTrackSatisfactionMonth(nextProps, nextState) {
    let { trackInputTrackSatisfactionMonth } = nextProps
    let { success, msg } = trackInputTrackSatisfactionMonth
    if (success) {
      wizNotice.success(msg)
      nextState.visible = false
      this.getList()
      return true
    }
    wizNotice.error(msg || '新增失败')
    return false
  }

  _trackSatisfactionMonthUpdate(nextProps, nextState) {
    let { trackSatisfactionMonthUpdate } = nextProps
    let { success, msg } = trackSatisfactionMonthUpdate
    if (success) {
      wizNotice.success(msg)
      nextState.visible = false
      this.getList()
      return true
    }
    wizNotice.error(msg || '保存失败')
    return false
  }

  _trackSatisfactionMonthDelete(nextProps, nextState) {
    let { trackSatisfactionMonthDelete } = nextProps
    let { success, msg } = trackSatisfactionMonthDelete
    if (success) {
      wizNotice.success(msg)
      this.getList()
      return true
    }
    wizNotice.error(msg || '删除失败')
    return false
  }

  _onBtn = (type, row) => {
    this.setState({
      modalInfo: row,
      modalTitleType: type,
      visible: true
    })
  }

  _onDelete = (row) => {
    const { processContentId } = this.state.record
    WizModal.confirm({
      title: '确定删除吗?',
      onOk: () => {
        this.doAction({
          path: 'counselingProcess/trackSatisfactionMonthDelete',
          payload: {
            key: 'trackSatisfactionMonthDelete@' + processContentId,
            apiParams: {
              id: row.id,
            }
          }
        })
      },
      onCancel() { }
    })
  }

  _onConfirm = () => {
    WizModal.confirm({
      title: '注意',
      content: '是否确认进行达标确认操作？',
      onOk: () => {
        this.markConfirmed()
      },
      onCancel() {
      }
    })
  }

  // modal弹出框内容
  _returnModalProps = () => {
    let { modalTitleType, visible } = this.state
    return {
      title: modalTitleType === 1 ? '录入满意度评估结果' : modalTitleType === 2 ? '查看点评' : "编辑满意度评估结果",
      visible,
      footer: null,
      width: 700,
      destroyOnClose: true,
      onCancel: () => {
        this.setState({ visible: false, modalInfo: {} })
      },
      afterClose: () => {
        this.setState({ visible: false, modalInfo: {} })
      }
    }
  }

  _onSubmitComment = (value) => {
    const { modalInfo } = this.state
    const { processContentId, tutorId } = this.state.record
    let trackSatisfactions = [];
    Object.keys(value).forEach(key => {
      if (key != 'month' && key != 'comment') {
        let element = value[key]
        trackSatisfactions.push(element);
      }
    });
    let valueNew = {
      month: moment(value.month).format('YYYY-MM'),
      comment: value.comment,
      trackSatisfactions: trackSatisfactions,
      fuseTutorId: tutorId
    }
    //编辑
    if (modalInfo && modalInfo.id) {
      this.doAction({
        path: 'counselingProcess/trackSatisfactionMonthUpdate',
        payload: {
          key: 'trackSatisfactionMonthUpdate@' + processContentId,
          apiParams: {
            ...valueNew,
            id: modalInfo.id
          }
        }
      })
    } else {
      //新增
      this.doAction({
        path: 'counselingProcess/trackInputTrackSatisfactionMonth',
        payload: {
          key: 'trackInputTrackSatisfactionMonth@' + processContentId,
          apiParams: {
            ...valueNew
          }
        }
      })
    }

  }

  //查看点评渲染内容
  _lookComment = () => {
    let { modalInfo } = this.state
    let { state, comment } = modalInfo
    return (
      <>
        <WizRow gutter={[20, 40]}>
          {/* <WizCol span={6} style={{ textAlign: 'right' }}>点评意见:</WizCol> */}
          <WizCol style={{marginLeft :"30px"}}>{comment}</WizCol>
        </WizRow>
      </>
    )
  }


  _disabledDate = (current) => {
    return current && current > moment().endOf('day')
  }

  // 点评渲染内容
  _addComment = () => {
    let modalInfo = this.state.modalInfo;
    console.log("modalInfo==", modalInfo);
    let columns = this.state.inputParam
    let record = undefined;
    let info = [];
    if (this.state.modalTitleType == 3) {
      record = modalInfo;
      info = record.trackSatisfactionList
      columns = this.state.headList;
    }
    let formColumns = [];
    let formColumnsBefore = [{
      title: "月度",
      formItem: {
        type: 'custom',
        render: (data, form) => {
          const { getFieldDecorator } = form;
          return (
            <div>
              {
                getFieldDecorator('month', {
                  rules: [{ required: true, message: '请选择年月', }],
                  initialValue: record && record.month ? moment(record && record.month) : undefined
                })(
                  <WizDatePicker.MonthPicker key='month'
                    format="YYYY-MM"
                    placeholder={'请选择年月'}
                    disabledDate={this._disabledDate}
                  />
                )
              }
            </div>
          )
        }
      }
    }]

    let formColumnsMiddle = assembleColumns(columns, info);
    let formColumnsAfter = [{
      title: '点评意见',
      name: 'comment',
      formItem: {
        type: 'textarea',
        placeholder: '点评意见最多输入200个字符',
        maxLength: 200,
        initialValue: record && record.comment,
        rules: [{
          required: true,
          message: '请输入点评意见',
        }, {
          validator: (rule, value, callback) => {
            if (value.replace(/\s*/g, '') === '') {
              callback('点评意见不能为空')
            }
            callback();
          }
        }]
      }
    }]
    formColumns = formColumnsBefore.concat(formColumnsMiddle).concat(formColumnsAfter)
    const footer = () => {
      return (
        <div className='form-btn'>
          <WizButton type='primary' htmlType='submit'>
            提交
          </WizButton>
        </div>
      )
    }

    const onSubmit = this._onSubmitComment.bind(this)
    let formProps = {
      ref: 'form',
      columns: formColumns,
      onSubmit,
      record: null,
      preview: null,
      footer: footer(),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 15, offset: 1 }
      }
    }
    return (
      <WizForm className='form-box' {...formProps} />
    )
  }

  /**
   * 达标确认按钮是否可用
   * 列表数据不为空， 且最后一条数据内容为达标状态可用
   */
  _confirmationState = () => {
    let { dataList, record } = this.state
    let { processContentState } = record
    return processContentState === 1 || dataList.length === 0 
    //|| dataList[dataList.length - 1]['state'] !== 1
  }

  render() {
    let { counselingProcessLoading } = this.props
    let { record, headList, dataList, modalTitleType } = this.state
    let tableProps = {
      columns: splicingHead(headList, this._onBtn, this._onDelete, this._confirmationState),
      dataSource: splicingData(dataList),
      pagination: false,
      bordered: true,
      scroll: { x: 'max-content' },
      rowKey: (e, i) => i
    }
    return (
      <WizSpin spinning={counselingProcessLoading} >
        <CounselingHeader record={record} />
        <WizCard title='满意度评估'>
          <div style={{ marginBottom: 20 }}>
            <WizButton type='primary' disabled={record.processContentState===1} style={{ marginRight: 15 }} onClick={() => this.getCheck()}>
              {'录入满意度评估结果'}
            </WizButton>
            <WizButton type='primary' disabled={this._confirmationState()} onClick={() => this._onConfirm()}>
              {'达标确认'}
            </WizButton>
          </div>
          <Table {...tableProps} />
        </WizCard>
        <WizModal  {...this._returnModalProps()}>
          {/* 1新增 2查看 3编辑  */}
          {modalTitleType === 2 ? this._lookComment() : this._addComment()}
        </WizModal>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const { processContentId } = findParamRecord(ownProps.history)
  const list = modelUtils.getModelEntity(counselingProcess, 'trackSatisfactionPageList@' + processContentId)
  const trackCheckSatisfaction = modelUtils.getModelEntity(counselingProcess, 'trackCheckSatisfaction@' + processContentId)
  const trackInputTrackSatisfactionMonth = modelUtils.getModelEntity(counselingProcess, 'trackInputTrackSatisfactionMonth@' + processContentId) // 点评
  const trackSatisfactionMonthUpdate = modelUtils.getModelEntity(counselingProcess, 'trackSatisfactionMonthUpdate@' + processContentId) // 点评
  const trackSatisfactionMonthDelete = modelUtils.getModelEntity(counselingProcess, 'trackSatisfactionMonthDelete@' + processContentId) // 点评
  const markConfirmed = modelUtils.getModelEntity(counselingProcess, 'satisfactionEvaluationNoticeTargetConfirm@' + processContentId) // 达标确认
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    markConfirmed,
    trackInputTrackSatisfactionMonth,
    trackSatisfactionMonthUpdate,
    trackSatisfactionMonthDelete,
    trackCheckSatisfaction,
    ...loading
  }
}

export default connect(mapStateToProps)(SatisfactionEvaluation)



// 表格head内容体拼接
const splicingHead = (headList = [], onBtn, onDelete, _confirmationState) => {
  let personId = storage.getStorage('user') && storage.getStorage('user').personId;
  let flag = '1cdf270fdc764dfb91634d3b2f48257f'===personId;
  let headMsg = headList.map(e => {
    return {
      title: e.name,
      dataIndex: `dataIndex${e.id}`,
      key: `dataIndex${e.id}`,
      align: 'center',
      width: 120,
      render: (text, row) => {
        return (
          <Tooltip placement='topLeft' title={text} transitionName={''}>
            <div className='text-ellipsis'>
              {text}
            </div>
          </Tooltip>
        )
      }
    }
  })

  // 配置动态数据之前的内容
  let beforCol = [{
    title: '月度',
    dataIndex: 'month',
    key: 'month',
    align: 'center',
    width: 100
  }]

  // 配置动态数据之前的内容
  let afterCol = [
    // {
    //   title: '是否达标',
    //   dataIndex: 'state',
    //   key: 'state',
    //   align: 'center',
    //   render: (text, row, index) => (text === 0 ? '否' : text === 1 ? '是' : null)
    // },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: 200,
      render: (text, row, index) => {
        let { comment, state } = row
        return (
          <WizButton.Group>
            {/* <WizButton type='link' disabled={state != 2} onClick={() => onBtn(1, row)}>
              {'点评'}
            </WizButton> */}
            <WizButton type='link' onClick={() => onBtn(2, row)}>
              {'查看点评'}
            </WizButton>
            <WizButton type='link' disabled={_confirmationState()} onClick={() => onBtn(3, row)}>
              {'编辑'}
            </WizButton>
            {flag?
            <WizButton type='link' disabled={_confirmationState()} onClick={() => onDelete(row)}>
            {'删除'}
          </WizButton>:<></>
            }
          </WizButton.Group>
        )
      }
    }
  ]
  return [...beforCol, ...headMsg, ...afterCol]
}

//  表格内容数据拼接
const splicingData = (dataList = []) => {
  let data = []
  dataList.map(e => {
    let obj = {
      month: e.month, // 第N次反馈
      reSubmit: e.reSubmit, // 是否显示重新反馈
      state: e.state === 0 ? e.state : e.state === 1 ? e.state : 2, // 是否达标
      cycle: e.cycle,
      comment: e.comment, // 点评
      trackSatisfactionList: e.trackSatisfactionList,
      id: e.id
    }
    e.trackSatisfactionList.map(c => {
      obj[`dataIndex${c.satisfactionId}`] = c.value // 动态标题对应内容
    })
    data.push(obj)
  })
  return data
}